import { Chip, Stack, Typography } from "@mui/material";

import LabelAndDisplay from "../../components/LabelAndDisplay";
import RevisionDeviationDetails from "../pricing-reports/RevisionDeviationDetails";

export default function FlyerGalleryDetailMetadata({ item }) {
  if (!item) {
    return (
      <Typography variant="body2" color="text.secondary">
        No record selected.
      </Typography>
    );
  }

  return (
    <Stack spacing={2}>
      <Typography variant="h6">{item.product}</Typography>
      <LabelAndDisplay label="Date" value={item.recordAt} />
      <LabelAndDisplay label="Product" value={item.product} />
      <LabelAndDisplay label="Retailer" value={item.retailer} />
      <LabelAndDisplay label="Province" value={item.province} />
      <LabelAndDisplay label="Unit price" value={item.unitPrice} />
      <LabelAndDisplay label="Price" value={item.price} />
      <LabelAndDisplay label="Weight" value={item.weight} />
      <LabelAndDisplay label="Original price" value={item.originalPrice} />
      <LabelAndDisplay label="Sale type" value={item.saleType} />
      <LabelAndDisplay label="Sale amount" value={item.saleAmount} />
      <LabelAndDisplay label="Human verified">
        {item.verified ? (
          <Chip size="small" color="success" label="Verified" />
        ) : (
          <Chip size="small" variant="outlined" label="Not verified" />
        )}
      </LabelAndDisplay>

      <RevisionDeviationDetails
        revisionStatus={item.revisionStatus}
        revisionMetadata={item.revisionMetadata}
        unitPriceValue={item.unitPriceValue}
      />
    </Stack>
  );
}
